import { StyleSheet } from 'react-native';
import { PALETTE } from '../../../../constants';

export default StyleSheet.create({
  container: {
    minHeight: 64,
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: '#0e1b34',
    opacity: 0.7,
    marginTop: 2,
    borderRadius: 2,
    borderWidth: 1,
    borderColor: 'transparent',
  },
  text: {
    flex: 1,
  },
  rowRight: {
    marginLeft: 5,
    marginRight: 5,
    width: 20,
  },
  portfolioText: {
    marginLeft: 5,
    marginRight: 5,
    minWidth: 140,
  },
});
